export enum BaseComponentTranslations {
  NumberInput_CalculationType = "NumberInput.CalculationType"
}
